import type { HTMLAttributes, ReactNode } from 'react'
import { cn } from '../../lib/utils'
import { Card as ShadcnCard, CardContent } from './shadcn/card'

export function Card({ className = '', children, ...props }: HTMLAttributes<HTMLDivElement>) {
  return (
    <ShadcnCard className={cn('gap-0 py-0 shadow-sm', className)} {...props}>
      {children}
    </ShadcnCard>
  )
}

export function CardHeader({
  title,
  action,
}: {
  title: ReactNode
  action?: ReactNode
}) {
  return (
    <div className="flex items-center justify-between gap-3 border-b border-border px-5 py-4">
      <h2 className="min-w-0 truncate text-card-title text-foreground">{title}</h2>
      {action && <div className="flex shrink-0 items-center gap-2">{action}</div>}
    </div>
  )
}

export function CardBody({
  className = '',
  children,
  ...props
}: HTMLAttributes<HTMLDivElement> & { className?: string; children: ReactNode }) {
  return (
    <CardContent className={cn('px-5 py-4', className)} {...props}>
      {children}
    </CardContent>
  )
}
